import React, {FC} from 'react';

import QuestionCardRadio from '../../components/QuestionCardRadio';
import QuestionCurrency from '../../components/QuestionCurrency';
import {REAL_ESTATE_OWNERSHIP_OPTIONS} from '../../constants';
import {useFhs} from '../../store/FhsContext/hooks';

import styles from './styles.module.scss';

const StepRealEstate: FC = () => {
  const {formData} = useFhs();
  const ownsRealEstate = formData.realEstateOwnership === 'yes';

  return (
    <div className={styles.stepRealEstate}>
      <QuestionCardRadio
        field="realEstateOwnership"
        options={REAL_ESTATE_OWNERSHIP_OPTIONS}
        shouldAdvanceFor={(value) => value === 'no'}
      />
      {ownsRealEstate && (
        <QuestionCurrency
          field="realEstateValue"
          label="What is the total value of your real estate?"
          hintText="Feel free to estimate."
        />
      )}
    </div>
  );
};

export default StepRealEstate;
